// LIBRARIES
// LIBRARIES
import styled from "styled-components";

// MISC
import { COLORS, DEVICE_TYPE, FONT_SIZE, SIZE } from "constants/variables";

export const MapNotice = styled.div`
  position: absolute;
  bottom: 32px;
  left: 24px;
  max-width: calc(100% - 48px);
  z-index: 60;
  background: ${COLORS.Cultured};
  color: ${COLORS.Gunmetal};
  padding: 12px 16px;
  border-radius: 12px;
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 8px 24px ${COLORS.boxShadow};
  font-size: 14px;
  p { margin: 0; font-weight: 600; }
  small { display: block; margin-top: 4px; }
  svg { flex-shrink: 0; color: ${COLORS.Crimson}; }
  button {
    border: 0; border-radius: 24px; background: ${COLORS.VividAuburn}; color: ${COLORS.Cultured};
    min-height: 44px; padding: 8px 12px; cursor: pointer; font: inherit; font-weight: 600;
    &:hover { background: ${COLORS.FaluRed}; }
    &:focus-visible { outline: 3px solid ${COLORS.Crimson}; outline-offset: 3px; }
  }
  @keyframes map-notice-spin { to { transform: rotate(360deg); } }
  @media (prefers-reduced-motion: no-preference) { .map-spinner { animation: map-notice-spin 1s linear infinite; } }
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    bottom: auto;
    top: calc(var(--map-controls-top, 96px) + 104px);
    left: 12px;
    max-width: calc(100% - 24px);
  }
`;

// MISC

export const Title = styled.h6`
  font-size: ${FONT_SIZE.max24};
  color: #333;
  align-self: center;
  margin-bottom: 5px;
`;

export const PreloaderWrapper = styled.div`
  position: absolute;
  z-index: 1000;
  background-color: rgba(29, 29, 38, 0.25);
  width: 100%;
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  pointer-events: none;
  flex-direction: column;
  gap: 12px;
  > p { background: ${COLORS.Cultured}; border-radius: 24px; padding: 12px 16px; margin: 0; font-size: 14px; font-weight: 600; }
`;

export const MapContainer = styled.div`
  /* The site header is 80px tall; keep controls 16px below it. */
  --map-controls-top: 96px;
  display: flex;
  width: 100%;
  height: 100dvh;
  position: relative;
  .map-cluster-control {
    border: 0;
    padding: 0;
    border-radius: 50%;
    background: transparent;
    cursor: pointer;
    touch-action: manipulation;
    &:focus-visible { outline: 3px solid ${COLORS.Crimson}; outline-offset: 4px; }
  }
`;

export const InterestPointsMenu = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: var(--map-controls-top, 96px);
  margin: 0;
  width: auto;
  @media (min-width: ${DEVICE_TYPE.fullHd}) {
    padding: 0 ${SIZE.max500};
  }
  text-transform: capitalize;
  font-size: 0.8em;
  font-weight: bold;
  z-index: 50;
  gap: ${SIZE.max12};
  padding: 0 ${SIZE.max320};
`;
